export const compareThemes = (currentTheme, newTheme) => {
  try {
    if (typeof currentTheme !== "object" || typeof newTheme !== "object") {
      return false;
    }
    const currentThemeKeys = Object.entries(currentTheme);
    const newThemeKeys = Object.entries(newTheme);

    if (newThemeKeys.length !== currentThemeKeys.length) return false;

    return currentThemeKeys.every(([themeKey, themeValue]) => {
      if (newTheme.hasOwnProperty(themeKey)) {
        return newTheme[themeKey] === themeValue;
      }
      return false;
    });
  } catch (err) {
    console.error(err);
    return false;
  }
};
